import { useNavigate } from 'react-router-dom'
import { useRef, useState, useEffect } from 'react';
import Loader from '../Loader';
import { useParams } from 'react-router-dom';
import { useResetPasswordMutation } from '../../features/passwordReset/resetApiSlice';

const ForgetPassCard = () => {
  const navigate = useNavigate()
  const { token, id } = useParams();
  const userId= id
  const userRef = useRef()
  const errRef = useRef()
  const [password, setPassword] = useState('')
  const [errMsg, setErrMsg] = useState('')
  const [resetRequest, { isLoading }] = useResetPasswordMutation()
  const [submitted, setSubmitted] = useState(false);
  useEffect(()=>{
    userRef.current.focus()
  }, [])

  useEffect(()=>{
    setErrMsg('');
  }, [password])

  const handleSubmit = async (e)=>{
    e.preventDefault()
    try{
       await resetRequest({ userId, token, password}).unwrap()
       
       setSubmitted(true)
      
    }catch(err) {
      if(!err.status){
         setErrMsg('No Server Response')

      }else if(err.status === 400){
         setErrMsg('Missing Password')
      } else if(err.status === 404){
         setErrMsg('Invalid Token!')
      } 
      else if(err.status === 402){
       setErrMsg('Incorrect Password')
     } else{
         setErrMsg(err.data?.message);
      }
      errRef.current.focus();
      console.log(errMsg)
    }
 }
  const onLoginClick= ()=>{
    navigate('/login')
  }
  
 
  const errClass = errMsg ? "errmsg" : "offscreen"
  if(isLoading) return  <Loader />

  const handlePasswordInput= (e) => setPassword(e.target.value)
  return (
    <div className="py-5 px-6 bg-white w-[95%] sm:w-[75%] lg:max-w-[400px] m-auto rounded-[2rem] ">
    
    {submitted ? (
      <>
      <h1 className="mb-6 font-semibold text-4xl text-center">
        Forget Password
      </h1>
        <p className="text-center mt-8 text-lg font-semibold">
          Your Password is successfully reset you can login now
        </p>
        <div className="text-center">
        
        <a className="text-red-600 font-semibold cursor-pointer uppercase" onClick={onLoginClick}>
          Login?
        </a>
        </div>
        </>
      ) : (
       <>
      <h1 className="mb-6 font-semibold text-4xl text-center">
        Forget Password
      </h1>
      <p ref={errRef} className="mb-2" aria-live="assertive">{errMsg}</p>
      <form onSubmit={handleSubmit}>
        
        <div className="mb-2">
          <label className="font-semibold inline-block mb-2" htmlFor="username">
            Enter you new Password
          </label>
          <input
            type="password"
            id="username"
            placeholder="Enter your new Password"
            className="bg-gray-100 h-10 w-full border-2 border-gray-300 rounded-lg px-4 focus:outline-none"
            ref={userRef}
            value={password}
            onChange={handlePasswordInput}
          />
        </div>
        <div className="mb-6 text-end text-sm"></div>

        <div className="text-center">
          <button className="py-2 px-8 rounded-full text-lg font-semibold text-white bg-black uppercase">
            Submit
          </button>
        </div>
      </form>

      <div className="text-center">
        <p className="mt-2 font-semibold">OR</p>
        <a className="text-red-600 font-semibold cursor-pointer uppercase" onClick={onLoginClick}>
          Login?
        </a>
        </div>
       </>
      )}
    </div>
    
  );
};

export default ForgetPassCard;
